import { useState } from "react";
import { Languages } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, setNarrationVoice } from "@/lib/api";

const OPTIONS = [
  { value: "en_riya", label: "English (Riya)", tag: "Default", sample: '"Let\'s subtract 5 from both sides."' },
  { value: "en_standard", label: "English (Classic)", sample: '"Let\'s subtract 5 from both sides."' },
  { value: "hi_mixed", label: "Hindi (Mixed)", sample: '"numerator को बदलना है, फिर simplify करते हैं।"' },
];

export default function SettingsModal({ open, onOpenChange, student }) {
  const [saving, setSaving] = useState(false);
  const [current, setCurrent] = useState(student?.narration_voice || "en_riya");

  const choose = async (value) => {
    if (value === current || saving) return;
    setSaving(true);
    try {
      await api.patch(`/students/${student.id}`, { narration_voice: value });
      setNarrationVoice(value);
      setCurrent(value);
      toast.success("SmartGuru's voice has been updated!");
    } catch {
      toast.error("Couldn't update the setting. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="settings-modal" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Languages size={18} className="text-primary" /> Voice Settings</DialogTitle>
          <DialogDescription>Choose the voice and language SmartGuru speaks its explanations in. The on-screen text always stays in English.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              data-testid={`narration-voice-option-${opt.value}`}
              onClick={() => choose(opt.value)}
              disabled={saving}
              className={`w-full text-left border-2 rounded-2xl p-4 transition-colors ${current === opt.value ? "border-primary bg-primary/5" : "border-border hover:border-primary/40"}`}
            >
              <p className="font-heading font-bold text-sm">
                {opt.label} {current === opt.value && <span className="text-primary text-xs">(Selected)</span>}
                {opt.tag && current !== opt.value && <span className="text-muted-foreground text-xs font-normal ml-1">({opt.tag})</span>}
              </p>
              <p className="text-xs text-muted-foreground mt-1 font-notebook">{opt.sample}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
